export const defaultContent = {
  topics: [{},{}]
}

export const numScenariosOptions = [
  {
    value: 1,
    label: 1
  },
  {
    value: 2,
    label: 2
  },
  {
    value: 3,
    label: 3
  }
]

export const formatOptions = [
  {
    value: '',
    label: ''
  },
  {
    value: 'desk',
    label: 'Text'
  },
  {
    value: 'image',
    label: 'Image'
  }
]